import React from "react";
import { FieldProps } from "@rjsf/utils";
import { UserRoleNames } from "common/authorization/policies";
import { AuthContext } from "../../Authorization/AuthContext";
import UserSelect from "../../Common/UserSelect";
import { Input } from "../__styles__/Inputs";
import { useDefaultedValue } from "../utils";

export const UserInput = (props: FieldProps) => {
  const { account } = React.useContext(AuthContext);
  const accountGroups = account?.groups || [];
  const userGroupSelection: string[] =
    props.uiSchema?.["ui:userGroupSelection"] || [];

  const existingValue = props.formData || {};
  const { value } = useDefaultedValue({
    value: existingValue,
    uiSchema: props.uiSchema,
    onChange: props.onChange,
  });

  const includeUsers = userGroupSelection.some(
    item => typeof item === "string" && UserRoleNames.includes(item)
  );

  const groups = userGroupSelection.filter(item => {
    if (typeof item === "string") {
      return accountGroups.find(group => group.name === item)?.name;
    }
    return item;
  });

  const includePublicUsers = groups.length > 0;

  return (
    <Input
      id={props.idSchema.$id}
      isSubmissionBuilder={props.isSubmissionBuilder}
    >
      <UserSelect
        value={value}
        onChange={props.onChange}
        name={props.name}
        required={props.required && !props.disabled}
        label={props.schema.title}
        error={props.rawErrors?.join(", ")}
        disabled={props.disabled}
        tooltip={props.uiSchema?.["ui:tooltipText"]}
        helperText={props.uiSchema?.["ui:helperText"]}
        placeholder={props.uiSchema?.["ui:placeholder"]}
        includeUsers={includeUsers}
        includePublicUsers={includePublicUsers}
        groups={groups}
      />
    </Input>
  );
};
